import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import useChangeTabs from '../../../hooks/useChangeTabs';
import useBottomNavValue from '../../../hooks/useAccountNavValue';
import { colors } from '../../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import { requiresBottomSafeArea } from '../../../../../../core/util/device';

const BottomNav = styled(({ needsSafeArea, ...rest }) => <BottomNavigation {...rest} />)`
  bottom: 0;
  width: 100%;
  z-index: 100;
  position: fixed;
  padding-bottom: env(safe-area-inset-bottom);
  ${(props) =>
    props.needsSafeArea &&
    css`
      padding-bottom: 24px;
    `};
  box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.12);

  && .root {
    transition: color 200ms ease;
  }

  && .selected .label {
    color: ${colors.grey600};
    font-size: ${fontSize.small};
    font-family: ${fontFamily.medium};
  }

  && .selected .wrapper svg {
    color: ${colors.crunchBerry};
  }

  && .label {
    font-size: ${fontSize.small};
    font-family: ${fontFamily.book};
    color: ${colors.grayMatter};
    letter-spacing: 0.55px;
    line-height: 16px;
  }

  && .wrapper svg {
    color: ${colors.lightText};
  }
`;

type Props = {
  viewName?: string;
  children: React.ReactElement[];
};

const StuckToTheBottom = (props: Props) => {
  const { viewName, children } = props;

  const value = useBottomNavValue(viewName);
  const onChangeCallback = useChangeTabs();

  return (
    <BottomNav
      needsSafeArea={useMemo(requiresBottomSafeArea, [])}
      onChange={onChangeCallback}
      showLabels
      value={value}
    >
      {children}
    </BottomNav>
  );
};

export default StuckToTheBottom;
